import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum TradeOrderFilterType {
  ALL,
  LIMIT,
  BENCHMARK,
  ALGO,
}

export class TradeTypeFilterHelper {
  /**
   * Check to see trade passes the trade type filter
   * @param filterType
   * @param riskTrade
   * @returns
   */
  public static doesFilterPass(
    filterType: TradeOrderFilterType,
    riskTrade: { orderType: CubiqTS.OrderType },
  ): boolean {
    if (!riskTrade) {
      return false;
    }

    switch (filterType) {
      case TradeOrderFilterType.ALL:
        return true;
      case TradeOrderFilterType.LIMIT:
        return (
          riskTrade.orderType === CubiqTS.OrderType.LIMIT_TP ||
          riskTrade.orderType === CubiqTS.OrderType.LIMIT_SL ||
          riskTrade.orderType === CubiqTS.OrderType.LIMIT_CALL ||
          riskTrade.orderType === CubiqTS.OrderType.MARKET
        );
      case TradeOrderFilterType.BENCHMARK:
        return riskTrade.orderType === CubiqTS.OrderType.BENCHMARK;
      case TradeOrderFilterType.ALGO:
        return riskTrade.orderType === CubiqTS.OrderType.ALGO;
    }
  }
}
